import Vue from 'vue';

export const getAuditLogs = async ({ commit }, filters = {}) => {
  try {
    const {
      page = 1,
      limit = 20,
      category = '',
      action = '',
      status = '',
      organizationId = '',
      actor = '',
      startDate = '',
      endDate = ''
    } = filters;

    let url = `/audit-logs?adminOnly=true&page=${page}&limit=${limit}`;

    if (category) url += `&category=${category}`;
    if (action) url += `&action=${action}`;
    if (status) url += `&status=${status}`;
    if (organizationId) url += `&organizationId=${organizationId}`;
    if (actor) url += `&actor=${actor}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;

    const { data } = await Vue.axios({ method: 'GET', url });
    commit('setAuditLogsPaginated', data);
    return { status: true, data };
  } catch (error) {
    return { status: false, message: error };
  }
};

export const getAuditStats = async ({ commit }, filters = {}) => {
  try {
    const { organizationId = '', startDate = '', endDate = '' } = filters;

    let url = '/audit-logs/stats?adminOnly=true';
    if (organizationId) url += `&organizationId=${organizationId}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;

    const { data } = await Vue.axios({ method: 'GET', url });
    commit('setAuditStats', data);
    return { status: true, data };
  } catch (error) {
    return { status: false, message: error };
  }
};

export const getAuditLogById = async ({ commit }, id) => {
  try {
    const { data } = await Vue.axios({ method: 'GET', url: `/audit-logs/${id}` });
    commit('setAuditLogDetail', data);
    return { status: true, data };
  } catch (error) {
    return { status: false, message: error };
  }
};
